import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Ukbusinessvisaimport from "@/pages/ukbusinessvisaimport";
const Ukbusinessvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/ukimg.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          <div className="absolute bottom-5 left-5 text-3xl font-bold text-[#011473] drop-shadow-md">
         
         
          </div>
        </div>
      </div>
      <div className=" md:ml-32 mt-10 w-full md:w-3/4 text-center md:text-center text-3xl font-bold text-[#011473] drop-shadow-md">
  UK Business Visa: Your Pathway to Global Success. Apply Now!
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/ukbussiness.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
  

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Age:</a> Applicants must meet the age requirements.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Points:</a> Must achieve the required points score.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">English:</a> Proof of English proficiency is necessary.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Permanent Residency:</a> Provides permanent residence for the applicant and their family.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Stay:</a> Allows indefinite stay in Australia.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Work & Study:</a> Full rights to work and study in Australia.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Medicare:</a> Access to Australia’s healthcare system.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Citizenship:</a> Eligibility for Australian citizenship.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Sponsorship:</a> Can sponsor eligible relatives for permanent residency.
    </span>
  </div>
</div>


      </div>
      <Ukbusinessvisaimport />
      <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
  <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-5xl">
    Advantages of the UK Business Visa
  </p>
  <div className="container mx-auto mb-10 mt-14">
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
      <div className="flex items-center justify-center">
        <img
          src="/bussines.jpg" // Replace with your image URL
          alt="Investment"
          className="w-full h-auto rounded-xl shadow-md"
        />
      </div>
      <div className="flex flex-col justify-left text-black text-left md:text-left pl-4">
        <ul className="list-disc pl-5 mb-4">
          <li><strong>Access to a Flourishing Economy:</strong> The UK is a leading global economy with abundant opportunities for business growth and success.</li>
          <li><strong>Strategic Market Hub:</strong> Situated at the crossroads of Europe and the rest of the world, the UK is a prime location for tapping into international markets.</li>
          <li><strong>Highly Skilled Workforce:</strong> Gain access to a talented and diverse workforce with expertise across various sectors.</li>
          <li><strong>Innovation and Technological Excellence:</strong> The UK is known for its advancements in technology and innovation, providing businesses access to cutting-edge research and tools.</li>
          <li><strong>Robust Legal System:</strong> The UK offers a transparent and stable legal framework, making it a secure and reliable environment for business operations.</li>
          <li><strong>Expansive Networking Opportunities:</strong> Build connections with an extensive network of entrepreneurs, investors and industry leaders to propel your business forward.</li>
        </ul>
      </div>
    </div>
  </div>
</div>


<div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
  <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-4xl">
    Why Partner With Visa World for Your UK Business Visa?
  </p>
  <div className="container mx-auto mb-10 mt-14">
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
      <div className="flex flex-col justify-left text-left md:text-left pl-4">
       
        <ul className="list-disc pl-5 text-black mb-4">
          <li><strong>Specialized Guidance:</strong> We offer customized solutions tailored to meet your unique business needs.</li>
          <li><strong>End-to-End Support:</strong> From the initial consultation to post-visa settlement, we handle every aspect of your UK Business Visa application.</li>
          <li><strong>Endorsement Expertise:</strong> We help you secure the necessary endorsements for Innovator and Start-up visas, ensuring your application is successful.</li>
          <li><strong>Proven Success Rate:</strong> We have a strong history of successfully assisting clients with their visa applications.</li>
          <li><strong>Continuous Assistance:</strong> Our team offers ongoing support, ensuring a smooth transition as you establish your business in the UK.</li>
        </ul>
       
      </div>
      <div className="flex items-center justify-center">
        <img
          src="/ukbussiness.jpg" // Replace with your image URL
          alt="Visa World Business"
          className="w-full h-96 rounded-xl shadow-md"
        />
      </div>
    </div>
  </div>
</div>

      
<div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center rounded-md text-black bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>Abundant Opportunities</strong>: The UK is a prime destination for business professionals and entrepreneurs aiming to grow and diversify.
        <br />
        - <strong>Thriving Economy</strong>: With a strong and stable economy, the UK fosters an environment for innovation and success.
        <br />
        - <strong>Strategic Location</strong>: Positioned as a global business hub, the UK connects you to international markets.
        <br />
        - <strong>Diverse Business Ecosystem</strong>: The UK offers a supportive and multicultural environment for new ventures and expansions.
        <br />
        - <strong>Pathway to Success</strong>: The UK Business Visa opens doors to start, expand, or explore business opportunities in one of the world’s leading economies.
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Why Choose the UK for Business?
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>



      <Contacts />
    </>
  );
};

export default Ukbusinessvisa;
